/**
 * Module dependencies.
 */

import { Field } from 'app/components/organisms/field/field';
import React from 'react';
import ReactJson from 'react-json-view';

/**
 * `Props` type.
 */

type Props = {
  item: any;
};

/**
 * Export `TherapySyncLogDetail` component.
 */

export function TherapySyncLogDetail({ item }: Props): JSX.Element {
  return (
    <div>
      <Field title={'STATUS CODE'} value={item.responseStatus} />

      <Field title={'REQUEST'} value={<ReactJson src={JSON.parse(item.requestBody ?? '{}')} />} />

      <Field title={'RESPONSE'} value={<ReactJson src={JSON.parse(item.responseBody ?? '{}')} />} />

      {item.error && <Field title={'ERROR'} value={<ReactJson src={JSON.parse(item.error ?? '{}')} />} />}
    </div>
  );
}
